import { buy, deal, sale, faceId, tax } from 'icons/default';

export const companyReleaseCardsList = [
  {
    title: 'Se över dina kostnader',
    icon: buy,
  },
  {
    title: 'Försäkringserbjudande ingår',
    icon: deal,
  },
  {
    title: 'Samla alla leasingavtal på ett ställe',
    icon: sale,
  },
];

export const companyLeasingCardsList = [
  {
    title: 'Leasa begagnade bilar utan att gå via bilhandlare',
    icon: deal,
  },
  {
    title: 'Opartisk partner med kunskap om marknaden',
    icon: faceId,
  },
  {
    title: 'Erbjud finansiering om du säljer',
    icon: sale,
  },
];

export const companySellCardsList = [
  {
    title: 'Få upp till 20 % mer betalt genom Blipp',
    icon: buy,
  },
  {
    title: 'Enbart verifierade köpare',
    icon: faceId,
  },
  {
    title: 'Betalning direkt på kontot',
    icon: tax,
  },
];
